import { useLocation, Link } from "react-router-dom";
import style from "./MenuLink.module.scss";
import cn from "classnames";

export function MenuLink({
  link,
  onClick,
  label,
  icon,
}: {
  link?: string;
  onClick?: () => void,
  label: string;
  icon: JSX.Element;
}) {
  const location = useLocation();
  
  if (link) {
    return (
      <Link
        to={compareLink(link, true) ? location : link}
        className={cn(style.link, compareLink(link, false) && style.link_active)}
      >
        {icon}
        <span>{label}</span>
      </Link>
    );
  } else {
    return (
      <div
        className={style.link}
        onClick={onClick}
      >
        {icon}
        <span>{label}</span>
      </div>
    );
  }

  function compareLink(link: string, fullCompare: boolean) {
    const index = (process.env.NODE_ENV === "development") && window.location.pathname.includes("admin") ? 2 : 1

    if (fullCompare) {
      return (
        (location.pathname.length === link.split("?")[0].length) &&
        (location.pathname.split("/")[index] === link.split("?")[0].split("/")[index])
      );
    } else {
      return (
        (location.pathname.split("/")[index] === link.split("?")[0].split("/")[index])
      );
    }
  }
}

